import React, { useEffect, useRef, useState } from "react";
import styled from 'styled-components';
import { ReactPhotoSphereViewer } from 'react-photo-sphere-viewer';
//img
import j290 from '../assets/j_290.jpg';
import legendimg from '../assets/legend.png';
import sleepimg from '../assets/sleep.png';
//openlayers 
import "ol/ol.css"; // OpenLayers 기본 스타일
import { Map, View } from "ol";
import { fromLonLat } from "ol/proj";
import { OSM, TileWMS, Cluster, Vector as VectorSource } from "ol/source";
import { Tile as TileLayer, Vector as VectorLayer } from "ol/layer";
import { Style, Circle as CircleStyle, Fill, Stroke, Text, Icon,} from "ol/style";
import { Feature } from "ol";
import Point from "ol/geom/Point";
import Overlay from 'ol/Overlay';
import { gateway } from "../Data/gatewaydata";
import axios from 'axios';
import Header from "../components/Header";
import Footer from "../components/Footer";
import { XYZ } from 'ol/source';



const TrafficInformationPage = () => {
  //axios.defaults.adapter = require('axios/lib/adapters/xhr');
    const [currentImage, setCurrentImage] = useState(j290); // 초기 이미지 설정
    const [isExpanded, setIsExpanded] = useState(false);
    const [symbol, setSymbol] = useState('❮');
    const [selectedInfo, setSelectedInfo] = useState(null);
    const [routeName, setRouteName] = useState('경부선'); // 기본값 설정
    const [restAreas, setRestAreas] = useState([]); // 휴게소 목록 상태
    const [sleepAreas, setSleepAreas] = useState([]); // 졸음쉼터 목록 상태
    const [selectedRestArea, setSelectedRestArea] = useState(''); // 선택된 휴게소
    const [filteredData, setFilteredData] = useState([]);
    const [map, setMap] = useState(null);
    const [view, setView] = useState(null); // View 객체 저장
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [vworldVisible, setVworldVisible] = useState(false);
    const mapRef = useRef(null);
    const highwayOptions = ['경부선', '중앙선', '서해안선']; // 선택 가능한 고속도로

  // 고속도로 선택 시 졸음쉼터 목록 API 호출
  useEffect(() => {
    const fetchSleepAreas = async () => {
      try {
        const response = await axios.get(
          'http://api.data.go.kr/openapi/tn_pubr_public_drowsy_shelter_api',
          {
            params: {
              serviceKey: 'h59y864R6Hz+MLGtP047x8y7wu+naz4whRwgY+IVkqP9LYq0NZhQskdgWhbQ2Urx/5EqX74OCKPVXI0mghho1g==',
              type: 'json', // JSON 데이터 포맷 요청
              roadRouteNm: routeName, // 선택한 경로 값
              numOfRows: 100, // 한번에 가져올 데이터 수
              pageNo: 1, // 페이지 번호
            },
          }
        );
  
        const fetchedSleepAreas = response.data.response.body.items;
        setSleepAreas(fetchedSleepAreas);
      } catch (error) {
        console.error('Error fetching sleep area data:', error);
      }
    };
  
    fetchSleepAreas();
  }, [routeName]); // routeName 변경 시 API 호출
    
    // 고속도로 선택 시 휴게소 목록 API 호출
    useEffect(() => {
      const fetchRestAreas = async () => {
        try {
          const response = await axios.get('https://data.ex.co.kr/openapi/business/serviceAreaRoute', {
            params: {
              key: '4007645158',
              type: 'json',
              routeName: routeName,
              numOfRows: 100,
              pageNo: 1,
            },
          });
    
          // API 응답 데이터 구조 확인 후 적절히 수정
          const fetchedRestAreas = response.data.list?.map((area) => area.serviceAreaName) || [];
          setRestAreas(fetchedRestAreas);
          setSelectedRestArea(''); // 휴게소 초기화
        } catch (error) {
          console.error('Error fetching rest area data:', error);
        }
      };
    
      fetchRestAreas();
    }, [routeName]); 

    const basicInfo = {
      운영시간: `${selectedInfo?.open}~${selectedInfo?.close}`,
      전화번호: selectedInfo?.휴게소전화번호,
      대표음식: selectedInfo?.휴게소대표음식명,
    };
    
    const facilitiesInfo = {
      경정비: selectedInfo?.경정비가능여부 === "Y" ? "있음" : "없음",
      "전기차 충전소": selectedInfo?.전기차충전소유무 === "Y" ? "있음" : "없음",
      "LPG 충전소": selectedInfo?.LPG충전소유무 === "Y" ? "있음" : "없음",
      "주차면수": selectedInfo?.주차면수,
      "버스환승 가능": selectedInfo?.버스환승가능여부 === "Y" ? "가능" : "불가능",
    };
    
    const servicesInfo = {
      쉼터: selectedInfo?.쉼터유무 === "Y" ? "있음" : "없음",
      약국: selectedInfo?.약국유무 === "Y" ? "있음" : "없음",
      화장실: selectedInfo?.화장실유무 === "Y" ? "있음" : "없음",
      수유실: selectedInfo?.수유실유무 === "Y" ? "있음" : "없음",
      매점: selectedInfo?.매점유무 === "Y" ? "있음" : "없음",
      음식점: selectedInfo?.음식점유무 === "Y" ? "있음" : "없음",
    };

    //지도 관련 코드
    useEffect(() => {
      if (!routeName || !sleepAreas.length) return;

      // Tile Layer for the KoreaAOI layer
      const KoreaAOI = new TileLayer({
        source: new TileWMS({
          url: "http://dromii-v3.duckdns.org/geoserver/yeongju/wms",
          params: {
            LAYERS: 'yeongju:koreaAOI',
            TILED: true,
          },
          serverType: 'geoserver',
          transition: 0,
        }),
      });
    
      // Base Layer (OSM)
      const baseLayer = new TileLayer({
        source: new OSM(),
        visible: false,
      });

      const vworldLayer = new TileLayer({
        source: new XYZ({
          url: `http://api.vworld.kr/req/wmts/1.0.0/{apikey}/Satellite/{z}/{y}/{x}.jpeg`.replace(
            '{apikey}',
            '61C91BAF-6C05-3D8C-AC53-397EA4C8EEFB',
            
          ),
          crossOrigin: 'anonymous'
        }),
        visible: vworldVisible, // 초기 가시성
      });

      const GyeongbuExpress = new TileLayer({
        source: new TileWMS({
          url: "http://dromii-v3.duckdns.org/geoserver/V4/wms",
          params: {
            LAYERS: 'V4:GyeongbuExpress',
            TILED: true,
          },
          serverType: 'geoserver',
          transition: 0,
        }),
      });
      const WestCoastExpress = new TileLayer({
        source: new TileWMS({
          url: "http://dromii-v3.duckdns.org/geoserver/V4/wms",
          params: {
            LAYERS: 'V4:West CoastExpress',
            TILED: true,
          },
          serverType: 'geoserver',
          transition: 0,
        }),
      });
      const JungangExpress = new TileLayer({
        source: new TileWMS({
          url: "http://dromii-v3.duckdns.org/geoserver/V4/wms",
          params: {
            LAYERS: 'V4:JungangExpress',
            TILED: true,
          },
          serverType: 'geoserver',
          transition: 0,
        }),
      });
     
    
      // Filter the data based on the selected routeName
      const filtered = gateway.filter((item) => item.도로노선명 === routeName);
      setFilteredData(filtered);
    
      // Create features only for the filtered data
      const features = filtered.map((item) => {
        const { 경도, 위도, 휴게소명, 휴게소운영시작시각, 휴게소운영종료시각 } = item;
        const feature = new Feature({
          geometry: new Point(fromLonLat([경도, 위도])),
          ...item,
          name: 휴게소명,
          open: 휴게소운영시작시각,
          close: 휴게소운영종료시각,
        });
        return feature;
      });
    
      // Cluster Source for the features
      const clusterSource = new Cluster({
        distance: 50,
        source: new VectorSource({
          features: features,
        }),
      });
    
      // Style for the clusters
      const clusterLayerStyle = (feature, hover = false) => {
        const size = feature.get("features").length;
        const isHovered = hover;
    
        return [
          new Style({
            image: new CircleStyle({
              radius: isHovered ? 15 : 12, // Emphasize effect radius change
              stroke: new Stroke({
                color: isHovered ? "#3c3d37" : "#938A7F", // Emphasize effect color change
                width: 2,
              }),
              fill: new Fill({
                color: isHovered ? "#3c3d37" : "#938A7F",
              }),
            }),
          }),
          new Style({
            image: new CircleStyle({
              radius: isHovered ? 7 : 5,
              fill: new Fill({
                color: "#ffffff",
              }),
            }),
          }),
          
        ];
      };
    
      // Cluster Layer for the map
      const clusterLayer = new VectorLayer({
        source: clusterSource,
        style: (feature) => clusterLayerStyle(feature),
      });

      // 졸음쉼터 데이터를 기반으로 `Feature` 생성
      const sleepfeatures = sleepAreas.map((area) => {
        const { longitude, latitude, shltrNm } = area;
        // console.log(area);
        return new Feature({
          geometry: new Point(fromLonLat([ longitude, latitude])),
          name: shltrNm,
        });
      });
      const sleepclusterSource = new Cluster({
        distance: 50, // 클러스터링 거리
        source: new VectorSource({
          features: sleepfeatures, // 올바른 속성명 사용
        }),
      });
      // 클러스터 스타일 정의
      const sleepclusterLayerStyle = (feature) => {
        const size = feature.get("features").length;
        return new Style({
          image: new Icon({
            src: sleepimg,
            scale: size > 0.5 ? 0.23 : 0.5, // 클러스터 크기에 따라 이미지 크기를 조정
          }),
         
        });
      };
      // 클러스터 레이어 생성
      const sleepclusterLayer = new VectorLayer({
        source: sleepclusterSource,
        style: (sleepfeature) => sleepclusterLayerStyle(sleepfeature),
      });

      const initialView = new View({
        center: fromLonLat([127.9538, 36.3857]), // 초기 지도 중심 좌표
        zoom: 7.5,
        minZoom: 7,
      });
    
      // Map configuration
      const map = new Map({
        target: mapRef.current,
        layers: [KoreaAOI,vworldLayer,JungangExpress,WestCoastExpress,GyeongbuExpress, clusterLayer, sleepclusterLayer],
        view: initialView,
      });

      setMap(map);
      setView(initialView); // View 저장
    
      // Popup Element
      const popup = document.createElement("div");
      popup.id = "popup";
      popup.style.position = "absolute";
      popup.style.background = "white";
      popup.style.border = "1px solid #ccc";
      popup.style.padding = "5px";
      popup.style.borderRadius = "5px";
      popup.style.display = "none";
      document.body.appendChild(popup);
    
      // Pointer move event for showing popup
      map.on("pointermove", (event) => {
        let popupVisible = false;
        let hoverFeature = null;
    
        map.forEachFeatureAtPixel(event.pixel, (feature) => {
          const clusteredFeatures = feature.get("features");
          if (clusteredFeatures.length > 0) {
            hoverFeature = feature;
            const firstFeature = clusteredFeatures[0];
            const properties = firstFeature.getProperties();
    
            const coordinate = event.coordinate;
            const pixel = map.getPixelFromCoordinate(coordinate);
            popup.style.left = `${pixel[0] + 1}px`;
            popup.style.top = `${pixel[1] + 1}px`;
            popup.style.display = "block";
            popup.textContent = properties.name;
            popupVisible = true;
          }
        });
    
        // Update cluster style on hover
        clusterSource.getFeatures().forEach((feature) => {
          feature.setStyle(clusterLayerStyle(feature, feature === hoverFeature));
        });
    
        if (!popupVisible) {
          popup.style.display = "none";
        }
      });
    
      // Map click event to select a feature
      map.on("click", (event) => {
        map.forEachFeatureAtPixel(event.pixel, (feature) => {
          const clusteredFeatures = feature.get("features");
          if (clusteredFeatures.length === 1) {
            const properties = clusteredFeatures[0].getProperties();
            setSelectedInfo(properties);
          }
        });
      });
    
      // Mouse out event for resetting cluster styles
      map.on("pointerout", () => {
        popup.style.display = "none";
        clusterSource.getFeatures().forEach((feature) => {
          feature.setStyle(clusterLayerStyle(feature, false));
        });
      });
    
      // Cleanup function to remove the map and popup
      return () => {
        map.setTarget(null);
        document.body.removeChild(popup);
      };
    }, [routeName]); // Re-run effect whenever `routeName` changes

    // useEffect to handle visibility based on routeName
    useEffect(() => {
      if (map) {
        // Find the layers for each route
        const gyeongbuLayer = map.getLayers().getArray().find((layer) => {
          return layer.getSource() instanceof TileWMS && 
                layer.getSource().getParams().LAYERS === 'V4:GyeongbuExpress';
        });

        const westCoastLayer = map.getLayers().getArray().find((layer) => {
          return layer.getSource() instanceof TileWMS && 
                layer.getSource().getParams().LAYERS === 'V4:West CoastExpress';
        });

        const jungangLayer = map.getLayers().getArray().find((layer) => {
          return layer.getSource() instanceof TileWMS && 
                layer.getSource().getParams().LAYERS === 'V4:JungangExpress';
        });

        // Update visibility based on routeName
        if (gyeongbuLayer) {
          gyeongbuLayer.setVisible(routeName === '경부선');
        }
        if (westCoastLayer) {
          westCoastLayer.setVisible(routeName === '서해안선');
        }
        if (jungangLayer) {
          jungangLayer.setVisible(routeName === '중앙선');
        }
      }
    }, [routeName, map]);

    useEffect(() => {
      if (map) {
        const vworldLayer = map.getLayers().getArray().find((layer) => {
          return layer.getSource() instanceof XYZ;
        });
        if (vworldLayer) {
          vworldLayer.setVisible(vworldVisible);
        }
      }
    }, [vworldVisible, map]);

    // 사용자 위치로 이동하는 함수
    const moveToUserLocation = () => {
      if (!navigator.geolocation) {
        alert("Geolocation이 지원되지 않는 브라우저입니다.");
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          const userCoordinates = fromLonLat([longitude, latitude]); // 경도, 위도를 OpenLayers 좌표로 변환

          view.animate({
            center: userCoordinates, // 사용자 위치로 이동
            zoom: 15, // 확대 레벨
            duration: 1000, // 애니메이션 지속 시간 (밀리초)
          });
        },
        (error) => {
          console.error("사용자 위치를 가져오는 데 실패했습니다:", error);
          alert("사용자 위치를 가져올 수 없습니다.");
        }
      );
    };
    
    const handleClick = () => {
      setIsExpanded(!isExpanded); // 상태를 반전시킴
      setSymbol(prev => (prev === '❯' ? '❮' : '❯')); // 기호 변경
    };

    const handleZoomIn = () => {
      if (view) {
        view.setZoom(view.getZoom() + 1);
      }
    };

    const handleZoomOut = () => {
      if (view) {
        view.setZoom(view.getZoom() - 1);
      }
    };

    const togglePopup = () => {
      setIsPopupVisible((prev) => !prev);
    };

    const toggleVworldLayer = () => {
      setVworldVisible((prev) => !prev); // 상태 토글
    };


    const [height, setHeight] = useState("40vh");
  const [isResizing, setIsResizing] = useState(false);
  
  const startResize = (e) => {
    setIsResizing(true);

    // Prevent default behavior to avoid unintended scrolling on mobile
    e.preventDefault();
  };

  const performResize = (clientY) => {
    const windowHeight = window.innerHeight;
    const newHeight = windowHeight - clientY;

    // Constrain height to reasonable values
    if (newHeight >= 100 && newHeight <= windowHeight * 0.8) {
      setHeight(`${newHeight}px`);
    }
  };

  const handleMouseMove = (e) => {
    if (!isResizing) return;
    performResize(e.clientY);
  };

  const handleTouchMove = (e) => {
    if (!isResizing) return;
    performResize(e.touches[0].clientY);
  };

  const stopResize = () => {
    setIsResizing(false);
  };

  React.useEffect(() => {
    if (isResizing) {
      window.addEventListener("mousemove", handleMouseMove);
      window.addEventListener("touchmove", handleTouchMove);
      window.addEventListener("mouseup", stopResize);
      window.addEventListener("touchend", stopResize);
    } else {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("touchmove", handleTouchMove);
      window.removeEventListener("mouseup", stopResize);
      window.removeEventListener("touchend", stopResize);
    }

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("touchmove", handleTouchMove);
      window.removeEventListener("mouseup", stopResize);
      window.removeEventListener("touchend", stopResize);
    };
  }, [isResizing]);
   
    
    return(
      <>
       {/* <Header></Header> */}
       <Container>
          {/* <Tab onClick={handleClick} left={isExpanded ? '0px' : '50%'}>
          {symbol}
          </Tab> */}
          <MapContainer>
              {/* <Legend src={legendimg}/> */}

                <MapHeader>
                    <SelectHighway>
                    <select
                value={routeName}
                onChange={(e) => setRouteName(e.target.value)}
            >
                {highwayOptions.map((highway) => (
                    <option key={highway} value={highway}>
                        {highway}
                    </option>
                ))}
            </select>
                    </SelectHighway>
                    <SelectRestArea>
                    <select
    value={selectedRestArea}
    onChange={(e) => setSelectedRestArea(e.target.value)}
  >
    {/* <option value="" disabled>
      휴게소를 선택하세요
    </option> */}
    {restAreas?.length > 0 ? (
      restAreas.map((restArea) => (
        <option key={restArea} value={restArea}>
          {restArea}
        </option>
      ))
    ) : (
      <option value="" disabled>
        해당 고속도로에 휴게소 없음
      </option>
    )}
  </select>
                    </SelectRestArea>
                </MapHeader>
                <div 
                ref={mapRef} // 지도를 렌더링할 div 요소
                style={{
                  width: "100%",
                  height: "95%", // 지도 크기
                  backgroundColor:"#D9EFFA"
                }}
                ></div>

            </MapContainer>
            
            <InfoContainer height={height}>
             
            
              <InfoHeader>
            {selectedInfo ? (
              <>
          
                <div className="name-boxs">
                  <h2>{selectedInfo?.휴게소명} 휴게소</h2>
                  </div>
                
                
              </>
            ) : (
              <p>휴게소를 선택해주세요.</p>
            )}
            <ReactPhotoSphereViewer
                src={currentImage}
                width="100%"
                height="80vw"
                borderRadius="5px"
            />
              </InfoHeader>
              <IntroductionGateWayBox>
            
                {selectedInfo ? (
                  <>
                    {/* 기본 정보 섹션 */}
                    <IntroductionGateWay >
                    <div className="name-boxs">
                      <h2>{selectedInfo?.휴게소명} 휴게소</h2>
                      </div>
                    
                      <div className="info-box">
                        <h3>기본 정보</h3>
                        <ul>
                          {Object.entries(basicInfo).map(([key, value]) => (
                            <li key={key}>
                              <strong>{key}</strong> <span>{value || "정보 없음"}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </IntroductionGateWay>
                    <IntroductionGateWayTab>
                            편의 시설 및 서비스
                    </IntroductionGateWayTab>


                    {/* 편의 시설 섹션 */}
                  
                    <IntroductionGateWay>
                    
                      <ul>
                        {Object.entries(servicesInfo).map(([key, value]) => (
                          <li key={key}>
                            <strong>{key}</strong>: {value}
                          </li>
                        ))}
                      </ul>
                    </IntroductionGateWay>

                    {/* 서비스 섹션 */}
                    <IntroductionGateWayTab>
                            차량 정보
                    </IntroductionGateWayTab>
                  <IntroductionGateWay>
                  
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <ul>
                        {Object.entries(facilitiesInfo).map(([key, value]) => (
                          <li key={key}>
                            <strong>{key}</strong>: {value}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </IntroductionGateWay>
                </>
              ) : (
                <></>
              )}
              </IntroductionGateWayBox>
            </InfoContainer>
            <LayerBox onClick={togglePopup}>a</LayerBox>
              {isPopupVisible && (
                <LayerPopup>
                  <LayerPopupHeader>지도설정</LayerPopupHeader>
                  <LayerPopupBody>
                    <LayerControl>cctv</LayerControl>
                    <LayerControl onClick={toggleVworldLayer}
        style={{
          color: vworldVisible ? '#D5445C' : 'black',
          cursor: 'pointer',
        }}>위성</LayerControl>
                  </LayerPopupBody>
                </LayerPopup>
              )}
            <Userlocation onClick={moveToUserLocation}>📍</Userlocation>
            {/* <ZoomBox>
              <ZoomBtn style={{borderBottom:'1px solid #C0C0C0'}} onClick={handleZoomIn}>+</ZoomBtn>
              <ZoomBtn style={{borderTop:'1px solid #C0C0C0'}} onClick={handleZoomOut}>−</ZoomBtn>
            </ZoomBox> */}
            
            
        </Container>
        {/* <Footer></Footer> */}
      </>
       
    )
};

export default TrafficInformationPage;

const Container = styled.div`
  width:100%;
  display:flex;
  height:100vh;
  overflow:hidden;
  flex-direction: column;
  .ol-attribution ul{
    display:flex;
  
  }
  .ol-zoom {
    margin-top:20px;
    top: 0px;
    left: 7px;
    display:none;
  }
`;

const Tab = styled.div`
  position: absolute;
  width:30px;
  height:60px;
  background-color:white;
  top:60vh;
  left:${(props) => props.left};
  z-index:1000;
  border-radius: 0px 4px 4px 0px;
  border-left:1.5px solid #BFB4A5;
  display:flex;
  justify-content: center;
  align-items: center;
  color:#dbdbdb;
  &:hover {
  color: #BFB4A5; /* 원하는 색상으로 변경 */
`;

const InfoContainer = styled.div`
  position: fixed;
  bottom:0px;
  width:100%;
  flex-direction: column;
  display:${(props) => props.visible};
  border-radius: 15px 15px 5px 5px;
  background-color:white; 
  align-items: center;
  justify-content: center;
  height: ${(props) => props.height};
  transition: height 0.2s ease-in-out;
`;



const ResizeHandle = styled.div`
  width: 80%;
  height: 10px;
  cursor: ns-resize;
  background-color: #ddd;
  border-top: 8px solid #ccc;
  border-radius: 20px;
  margin-top:10px;
  
`;


const IntroductionGateWayBox = styled.div`
  padding: 10px;
  // height:20vh;
  overflow:hidden;
  overflow:scroll;
  padding-top: 20px;
  background-color: white;
  height:40%;
  margin-bottom:100px;
`;

const IntroductionGateWay = styled.div`
  display: flex;
  align-items: center;
  border-radius: 5px;
  padding: 20px;
  font-family: 'Arial', sans-serif;
  background-color: #fff;

  h2 {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px;
    color: #333;
  }

  p {
    font-size: 10px;
    color: #666;
    margin-bottom: 20px;
  }

  .name-boxs{
    width: 40%;
   display:flex;
   align-items:center;
   justify-content:center;
    border-radius: 5px;
    padding: 15px;

  }
  

  .info-box {
    width: 60%;
    border-left: 1px solid #e0e0e0;
    padding: 15px;

    h3 {
      font-size: 16px;
      font-weight: bold;
      color: #555;
      margin-bottom: 10px;
    }

    ul {
      list-style: none;
      padding: 0;

      li {
        display: flex;
        // justify-content: space-between;
        margin-bottom: 8px;
        font-size: 14px;

        strong {
          color: #555;
          font-weight: bold;
          margin-left:20px;
        }

        span {
          color: #333;
          margin-left:30px;
        }
      }
    }
  }
`;
const IntroductionGateWayTab = styled.div`
  width:100%;
  height:50px;
  background-color:#F3F3F3;
  display:flex;
  align-items:center;
  font-weight:800;
`;

const MapContainer = styled.div`
  height:100%;
  width:100%;
  display:flex;
  flex-direction: column;
  align-items:center;
`;
const MapHeader = styled.div`
  position: absolute;
  z-index:1000;
  top:10px;
  width:98%;
  height:50px;
  display:flex;
  border-bottom: 1px solid gray;
  background-color:white;
  border-radius:10px;
`;

const SelectHighway = styled.div`
  height:100%;
  width:50%;
  display:flex;
  align-items:center;
  padding:0px 20px;
  font-size:18px;
  font-weight:600;
  border-right: 0.5px solid gray;
`;
const SelectRestArea = styled.div`
  height:100%;
  width:50%;
  display:flex;
  align-items:center;
  padding:0px 20px;
  font-size:18px;
  font-weight:600;
  border-left: 0.5px solid gray;
`;


const InfoHeader = styled.div`
  display:flex;
  padding:10px;
  justify-content: space-between;
  flex-direction: column;
`
const LayerBox = styled.div`
  position: absolute;
  z-index:1000;
  right:10px;
  top:80px;
  width:40px;
  height:40px;
  border-radius:10px;
  background-color:#ffffff;
  display:flex;
  align-items:center;
  justify-content: center;
  &:hover{
    color:#D5445C
  }
`;

const Userlocation = styled.div`
  position: absolute;
  z-index:1000;
  right:10px;
  top:130px;
  width:40px;
  height:40px;
  border-radius:10px;
  background-color:#ffffff;
  display:flex;
  align-items:center;
  justify-content: center;
`

const ZoomBox = styled.div`
  position: absolute;
  z-index:1000;
  right:20px;
  top:96vh;
  width:40px;
  height:80px;
  border-radius:10px;
  background-color:white;
`;

const ZoomBtn = styled.div`
  width:40px;
  height:40px;
  display:flex;
  align-items:center;
  justify-content: center;
  font-size:18px;
  &:hover{
    color:#D5445C
  }
`

const LayerPopup = styled.div`
  position: absolute;
  z-index:1000;
  right:70px;
  top:70px;
  width:160px;
  height:130px;
  border-radius:10px;
  background-color:#ffffff;
  display:flex;
  flex-direction: column;
  justify-content: center;
  padding:10px 20px;
`

const LayerPopupHeader = styled.div`
  width: 100%;
  height:25px;
  display:flex;
  align-items:center;
  border-bottom: 1px solid #c0c0c0;
  font-size:12px;
`

const LayerPopupBody = styled.div`
`;

const LayerControl = styled.div`
  width:100%;
  height:30px;
  border: 1px solid #c0c0c0;
  border-radius:10px;
  margin-top:10px;
  display:flex;
  align-items:center;
  justify-content: center;
  &:hover{
    color:#D5445C;
    border: 1px solid #D5445C;
  }
`;

const Legend = styled.img`
  position: absolute;
  z-index:1000;
  max-width:120px;
  min-width:100px;
  width:12vw;
  top:130px;
  margin-left:20px;
`;